/* ==========================================================================
   assets/nb-collection.js — kollektionssiden
   Markup: sections/nb-collection-grid.liquid

   To progressive forbedringer. Begge er rene tilføjelser: siden virker
   fuldstændigt uden denne fil.

     1) Sortering
        <select> ligger i en <form method="get"> med en inline onchange, der
        submitter. Er JS tilgængeligt, fjernes den inline-handler og filen
        overtager: URL'en bygges ud fra den nuværende adresse, så aktive
        filtre og andre parametre bevares, "page" nulstilles, og
        scrollpositionen huskes hen over reloadet.

     2) "Vis flere"
        Knappen er et ægte <a> til næste side. Med JS hentes næste side i
        stedet, produktkortene indsættes i grid'et, og knap + tællertekst
        udskiftes med den nye sides egne — så al tekst kommer fra Liquid.
        Adressen opdateres med history.replaceState, så genindlæsning og
        deling rammer den side, brugeren står på.

   Regler: vanilla, ingen afhængigheder, ingen build-step, idempotent
   (init på DOMContentLoaded + shopify:section:load, alt bindes med et
   dataset-flag). INGEN kundevendt tekst i denne fil — labels læses fra
   data-attributter skrevet i Liquid.
   ========================================================================== */

(function (window, document) {
  'use strict';

  var SCROLL_KEY = 'nb-collection-scroll';

  /* ------------------------------------------------------------------ *
   * 1) Sortering
   * ------------------------------------------------------------------ */

  function initSort(scope) {
    var forms = (scope || document).querySelectorAll('[data-nb-sort-form]');

    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.dataset.nbSortBound === 'true') continue;
      form.dataset.nbSortBound = 'true';

      var select = form.querySelector('[data-nb-sort-select]');
      if (!select) continue;

      /* Inline-handleren er no-JS-fallbacken. Nu hvor JS kører, ville den
         submitte formularen og kaste de øvrige query-parametre væk. */
      select.removeAttribute('onchange');

      select.addEventListener('change', onSortChange);
    }
  }

  function onSortChange(event) {
    var select = event.currentTarget;
    var url;

    try {
      url = new URL(window.location.href);
    } catch (e) {
      /* Meget gamle browsere: lad formularen gøre arbejdet. */
      if (select.form) select.form.submit();
      return;
    }

    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');

    rememberScroll();
    window.location.assign(url.toString());
  }

  function rememberScroll() {
    try {
      window.sessionStorage.setItem(SCROLL_KEY, String(window.pageYOffset || 0));
    } catch (e) {
      /* Private mode uden storage — ingen konsekvens ud over et scroll-hop. */
    }
  }

  function restoreScroll() {
    var raw;
    try {
      raw = window.sessionStorage.getItem(SCROLL_KEY);
      window.sessionStorage.removeItem(SCROLL_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    var y = parseInt(raw, 10);
    if (isNaN(y) || y <= 0) return;

    /* Vent til grid'et har fået sin højde, så positionen findes. */
    window.requestAnimationFrame(function () {
      window.scrollTo(0, y);
    });
  }

  /* ------------------------------------------------------------------ *
   * 2) "Vis flere"
   * ------------------------------------------------------------------ */

  function initLoadMore(scope) {
    var buttons = (scope || document).querySelectorAll('[data-nb-loadmore]');

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.dataset.nbLoadmoreBound === 'true') continue;
      btn.dataset.nbLoadmoreBound = 'true';
      btn.addEventListener('click', onLoadMore);
    }
  }

  function onLoadMore(event) {
    var btn = event.currentTarget;
    var url = btn.getAttribute('href');
    if (!url) return;

    /* Nyt faneblad / gem-som skal stadig virke som et almindeligt link. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;

    event.preventDefault();

    if (btn.dataset.nbLoading === 'true') return;
    btn.dataset.nbLoading = 'true';
    btn.setAttribute('aria-busy', 'true');

    var loadingLabel = btn.getAttribute('data-nb-label-loading');
    if (loadingLabel) btn.textContent = loadingLabel;

    var gridId = btn.getAttribute('data-nb-target');
    var grid = gridId ? document.getElementById(gridId) : null;
    var wrap = btn.closest('[data-nb-loadmore-wrap]');

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var nextGrid = gridId ? doc.getElementById(gridId) : null;
        if (!nextGrid) nextGrid = doc.querySelector('[data-nb-collection-grid]');

        if (grid && nextGrid) {
          var added = [];
          while (nextGrid.firstElementChild) {
            var card = nextGrid.firstElementChild;
            nextGrid.removeChild(card);
            grid.appendChild(card);
            added.push(card);
          }

          /* Hjerterne skal afspejle localStorage med det samme.
             Selve klikket haandteres af en delegeret lytter paa document i
             nb-wishlist.js — den daekker allerede de nye kort. Det samme
             gaelder hurtig-tilfoej ([data-nb-quickadd] i nb-cart.js), der
             ogsaa er delegeret; derfor skal intet gen-initialiseres der. */
          if (window.NBWishlist && typeof window.NBWishlist.sync === 'function') {
            window.NBWishlist.sync(grid);
          }

          /* Fokus til det første nye kort — ellers mister tastaturbrugeren
             stedet, når knappen forsvinder. */
          focusFirst(added);
        }

        /* Knap + tæller udskiftes med næste sides egne, så teksten altid
           kommer fra Liquid. Findes de ikke, var det den sidste side. */
        var nextWrap = doc.querySelector('[data-nb-loadmore-wrap]');
        if (wrap) {
          if (nextWrap) {
            wrap.innerHTML = nextWrap.innerHTML;
            initLoadMore(wrap);
          } else {
            wrap.parentNode.removeChild(wrap);
          }
        }

        replaceUrl(url);
      })
      .catch(function () {
        /* Netværksfejl: giv linket tilbage, så et klik navigerer normalt. */
        restoreButton(btn);
        window.location.assign(url);
      });
  }

  function restoreButton(btn) {
    btn.dataset.nbLoading = 'false';
    btn.removeAttribute('aria-busy');
    var label = btn.getAttribute('data-nb-label-default');
    if (label) btn.textContent = label;
  }

  /* Fokus flyttes til det foerste NYE korts titel-link. Billedlinket springes
     over: det er aria-hidden og tabindex="-1", og fokus paa et skjult element
     efterlader skaermlaeseren uden kontekst. */
  function focusFirst(cards) {
    if (!cards.length) return;
    var link = cards[0].querySelector('a[href]:not([aria-hidden="true"])');
    if (!link) return;
    link.setAttribute('tabindex', '-1');
    try {
      link.focus({ preventScroll: true });
    } catch (e) {
      /* preventScroll ikke understøttet — spring fokus over. */
    }
  }

  function replaceUrl(url) {
    if (!window.history || !window.history.replaceState) return;
    try {
      window.history.replaceState({}, '', url);
    } catch (e) {
      /* Cross-origin eller blokeret history — uden betydning. */
    }
  }

  /* ------------------------------------------------------------------ *
   * 3) Init — idempotent
   * ------------------------------------------------------------------ */

  function init(scope) {
    initSort(scope);
    initLoadMore(scope);
  }

  if (!window.__nbCollectionBound) {
    window.__nbCollectionBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target || document);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
        restoreScroll();
      });
    } else {
      init(document);
      restoreScroll();
    }
  } else {
    init(document);
  }

  window.NBCollection = { init: init };
})(window, document);
